<template>
    <div class="container-fluid container_bStore">
        <article class="container-menu">
            <nav-category
                @clickItem="showSection($event)"
                @clickAction="openLateral($event)"
                @startMenu="iniRunMenu($event)"
            ></nav-category>
            <product-list
                @clickAction="openLateral($event)"
                @delproduct="delproductConfirm($event)"
                :urlMedia="urlMedia+path_base"
                :sectionActive="sectionActive"
                :key="sectionActive"
            ></product-list>
        </article>
        <!-- modal lateral-->
        <modalLateral>
            <component v-bind:is="m.component" ></component>
        </modalLateral>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import "./stylesGlobal.scss"
import nav_bStore from "./components/nav_bStore.vue"
import productList from "./components/productList.vue"
import bStore_setup from "./components/setup/bStore_setup.vue"
import productUpload from "./components/productUpload.vue"
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral'
export default {
    components:{
        'nav-category': nav_bStore,
        'product-list': productList,
        bStore_setup,
        productUpload,
        modalLateral,
    },
    data(){
        return {
            lang: {
                bs_error: '',
                bs_could_not_save: '',
                bsprod_remove_category_error: '',
                bsprod_swal_delete_prefix: '',
                bs_swal_text: '',
                bs_swal_confirm: '',
            },
            isLoading: false,
            apiProgess: 0,
            listCat2: [
                {
                    id: 1,
                    name: "Margaritas & Cocktails",
                    products : [
                        { name: "Triple Dipper™"},
                        { name: "Bone-In Wings"},
                    ],
                },
                {
                    id: 2,
                    name: "Appetizers",
                    products : [
                        { name: "White Skillet Queso"},
                        { name: "Fresh Guacamole"},
                        { name: "Chips & Salsa"},
                        { name: "Fried Mozzarella - Shareable"},
                        { name: "Fried Mozzarella - Small"},
                        { name: "Texas Cheese Fries"},
                    ],
                },
                {
                    id: 5,
                    name: "Big Mouth Burgers®",
                    products : [
                        { name: "Triple Dipper™"},
                        { name: "Bone-In Wings"},
                        { name: "Boneless Wings"},
                        { name: "Dip Trio"},
                        { name: "Southwestern Eggrolls"},
                        { name: "Skillet Queso"},
                        { name: "White Skillet Queso"},
                        { name: "Fresh Guacamole"},
                        { name: "Chips & Salsa"},
                        { name: "Fried Mozzarella - Shareable"},
                        { name: "Fried Mozzarella - Small"},
                        { name: "Texas Cheese Fries"},
                    ],
                },
                {
                    id: 6,
                    name: "Chicken Crisper® Combos",
                    products : [],
                },
                {
                    id: 7,
                    name: "Steaks & Ribs",
                    products : [],
                },
            ],
            listCat: [],
            categoryActive: null,
            apis: null,
            pagRows: 0,
            searchCategory: null,
            filter_status: [0, 1],
            ordenKey: 'orden',
            ordenVal: 'ASC',
            filter_group: [],
            urlMedia: null,
            path_base: null,
            m: {
                show: false,
                component: '',
                data: []
            },
            sectionActive: null,
        };
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = t.$store.getters['ModApps/Marketea/urlApis'];
        t.apis = urlApis.bStore;
        // console.log('rutas', t.apis)
        t.getNoti();
        t.getList();
    },
    mounted(){
        let t = this;
    },
    computed: {
        ...mapGetters("core", { getPusher: "get_accitonPusher"}),
        ...mapGetters("ModApps/Marketea/", { langGetter: "lang" }),
    },
    methods: {
        getNoti(){
            let t = this;
            let urlService = t.apis.get(2)// getInfo
            window.master.post(urlService, {
                user_id: window.master_client,
                org_id: window.localorgdata,
            })
            .then((response) => {
                // console.log(urlService, response.data);
                if (response.data.status) {
                    let setUpdate = response.data.info;
                    t.$store.commit('ModApps/Marketea/set_bStore_info', setUpdate);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getList(noLoad){
            let t = this;
            let urlService = t.apis.get(0); //setCat
            if(noLoad==undefined){t.isLoading = true;}
            // @ts-ignore
            window.master.post(urlService, {
                user_id: window.master_client,
                org_id: window.localorgdata,
                pusher_id: pusher.connection.socket_id,
                rows: t.pagRows,
                filter_group: t.filter_group,
                filter_name: t.searchCategory,
                filter_status: t.filter_status,
                ordenKey: t.ordenKey,
                ordenVal: t.ordenVal,
            }, {
                headers: {
                    common: {
                    // @ts-ignore
                    Authorization: 'Bearer ' + window.localtoken_M
                    },
                    // post: { 'Content-Type': 'multipart/form-data' }
                },
                onUploadProgress: (progressEvent) => {
                    // console.log('onUploadProgress', progressEvent)
                    let scanPer = Math.floor(
                        (progressEvent.loaded*100 / progressEvent.total)
                    );
                    // console.log('scanPer', scanPer);
                    if(scanPer < 99){
                        t.apiProgess = scanPer;
                    }
                }
            })
            .then((response) => {
                t.apiProgess =100;
                // @ts-ignore
                // console.log(urlService, response.data);
                t.urlMedia = response.data.path.url;
                t.path_base = response.data.path.path_base;
                if(response.data.list.total>0){
                    t.listCat = response.data.list.data;
                    // console.log(urlService, t.listCat)
                    t.categoryActive = t.listCat[0];
                    t.setStore('bStore_listCat', t.listCat);
                    t.setStore('bStore_catActive', t.categoryActive);
                    if(response.data.currency){
                        t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                    }
                }else{
                    t.setStore('bStore_listCat', []);
                    t.setStore('bStore_catActive', null);
                }
                t.isLoading = false;
            }).catch((error) => {
                console.log(error);
                t.apiProgess =0;
                t.isLoading = false;
            });
        },
        setStore(key, val){
            let t = this;
            t.$store.commit('ModApps/Marketea/set_bStoreValStorage', {key, val});
        },
        showSection($event){
            console.log('showSection', $event)
            let t = this;
            t.indicadorMenu($event);
            this.sectionActive = $event;
            t.sectBg()
        },
        indicadorMenu(elemtId){
            const menu = document.querySelector('.nav-category');
            const indicador = document.getElementById('indicador');
            let listNav = menu.querySelectorAll('ul.menu-categores li');
            if(listNav.length > 2){
                let itemActivo = menu.querySelector('ul.menu-categores li a.active');
                const product_list = document.querySelector('.container_product_list');
                const secciones = document.querySelectorAll('.product_seccion');
                if(itemActivo){
                    let tamaNioIndicador = itemActivo.offsetWidth;
                    indicador.style.width = tamaNioIndicador + 'px';
                    // Volvemos a posicionar el indicador.
                    let indexSeccionActiva = itemActivo.offsetLeft
                    indicador.style.transform = `translateX(${indexSeccionActiva}px)`;
                    // console.log('indicador width', indicador.style.width);
                    // console.log('indicador translateX', indexSeccionActiva);
                    // console.log('menu.offsetWidth', menu.offsetWidth);
                    let leftScroll = menu.offsetWidth - (indexSeccionActiva+tamaNioIndicador);
                    // console.log('leftScroll', leftScroll)
                    if(leftScroll < 0){
                        menu.scrollLeft = (leftScroll * -1) + 40;
                        // console.log('scrollLeft --', menu.scrollLeft)
                    }else if(leftScroll > 0){
                        menu.scrollLeft-= leftScroll;
                        // console.log('scrollLeft ++', menu.scrollLeft)
                    }
                }else{
                    indicador.style.width = '0px';
                    indicador.style.transform = `translateX(0px)`;
                }
            }
        },
        sectBg(){
            let idS = "section-" + this.sectionActive;
            // console.log('sectBg', idS)
            if (document.querySelectorAll('.product_seccion').length > 0 && document.getElementById(idS)) {
                document.querySelectorAll('.product_seccion').forEach(s => {
                    // console.log('remove active', s.id)
                    if (document.getElementById(s.id).classList.contains('active')) {
                        // console.log('remove active', s.id)
                        document.getElementById(s.id).classList.remove('active');
                    }
                });
                setTimeout(() => {
                    document.getElementById(idS).classList.add('active');
                }, 200);
            }
        },
        iniRunMenu(event){
            // console.log('iniRunMenu', event)
            let t = this;
            const mainNav = document.querySelector(".main-nav-category");
            if(mainNav){
                const ulMenuCat = document.querySelector("ul.menu-categores");
                if(ulMenuCat){
                    let navCat = 0;
                    ulMenuCat.querySelectorAll('li').forEach(li => {navCat += li.offsetWidth});
                    if(navCat < mainNav.offsetWidth){
                        ulMenuCat.offsetWidth
                        let liWidth = mainNav.offsetWidth / ulMenuCat.querySelectorAll('li').length;
                        if(liWidth>0 && ((liWidth * ulMenuCat.querySelectorAll('li').length)>=mainNav.offsetWidth)){
                            console.log('ok', liWidth)
                            ulMenuCat.querySelectorAll('li').forEach(li => {
                                li.style.flex='auto';
                                li.style.display='flex';
                                li.style.justifyContent='center';
                            });
                            ulMenuCat.style.width='100%';
                            ulMenuCat.style.justifyContent='space-around';
                        }else{console.log('error', liWidth)}
                    }
                    this.indicadorMenu(event);
                }
            }
        },
        openLateral(event) {
            let t = this;
            t.m.show= true;
            t.m.component= event.name;
            t.m.data=event.data;
            t.$store.commit('core/setOpenModal', t.m);
        },
        delproductConfirm(product){
            let t = this;
            // console.log('delproductConfirm', product)
            if(!product || product.id==0){
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bsprod_remove_category_error,
                });
            }else{
                t.$swal({
                    title: t.lang.bsprod_swal_delete_prefix + ' ' + product.product_name + '?',
                    text: t.lang.bs_swal_text,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: t.lang.bs_swal_confirm,
                }).then((result) => {
                    if (result.value) {
                        console.log('delete product', product.product_name)
                        t.$store.commit('ModApps/Marketea/set_bStoreDelProductItem', product);
                        t.deleteproduct(product);
                    }
                });
            }
        },
        deleteproduct(i){
            let t = this;
            if (i.id > 0) {
                let urlService = t.apis.set(8)// deleteproduct
                window.master.post(urlService, {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    id: i.id,
                    pusher_id: pusher.connection.socket_id,
                })
                .then((response) => {
                    console.log(urlService, response.data);
                })
                .catch((error) => {
                    console.log(error);
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bs_could_not_save,
                    });
                });
            }
        },
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        getPusher: function(){
            let t = this;
            let g = t.getPusher;
            // pusher.connection.socket_id
            if(g.data.org_id==window.localorgdata){
                if(g.data.action=='CategoryItem' && g.data.ope=="create"){
                    let payload = {key: 'bStore_listCat', val: g.data.getItem};
                    t.$store.commit('ModApps/Marketea/set_bStoreNewItem', payload);
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
